<template>
  <el-dialog :visible="visible" @close="$emit('update:visible', false)" :before-close="beforeClose" class="dialog-w40">
    <h2 class="text-center my-0">{{title}}</h2>

    <el-form :model="form" :rules="rules" ref="form">
      <div class="row mt-5">
        <div class="col-12">
          <el-form-item prop="name">
            <el-input type="textarea"
                      :rows="4"
                      maxlength="100"
                      show-word-limit
                      v-model="form.name"
                      resize="none"/>
            <span class="floating-span" :class="{ 'floating-span_active': $notEmpty(form.name) }">Название</span>
          </el-form-item>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-12 col-sm-6 mx-auto">
          <el-button class="w-100" type="primary" :loading="actionProgress"
                     @click="onSubmit">{{btnText}}</el-button>
        </div>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import { MESSAGES } from '@/commons/constants/errorMessages';

export default {
  props: {
    visible: Boolean,
  },

  data: () => ({
    isEditMode: false,
    form: {
      name: '',
    },

    rules: {
      name: [
        { required: true, message: MESSAGES.REQUIRED, trigger: 'change' },
      ],
    },
  }),

  created() {
    if (this.item) {
      this.form.name = this.item.name;
      this.isEditMode = true;
    } else {
      this.isEditMode = false;
    }
  },

  destroyed() {
    this.setItem(null);
  },

  computed: {
    ...mapGetters({
      item: 'registryTypes/item',
      actionProgress: 'registryTypes/actionProgress',
    }),
    title() {
      return this.isEditMode ? 'Редактировать тип реестра' : 'Добавить тип реестра';
    },
    btnText() {
      return this.isEditMode ? 'Сохранить' : 'Создать';
    },
  },

  methods: {
    ...mapMutations({
      setItem: 'registryTypes/setItem',
    }),
    ...mapActions({
      createItem: 'registryTypes/createItem',
      updateItem: 'registryTypes/updateItem',
    }),
    beforeClose(done) {
      if (!this.actionProgress) {
        done();
      }
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.isEditMode) {
            this.updateItem({ id: this.item.id, data: this.form })
              .then(() => {
                this.$emit('update:visible', false);
              }).catch(() => {});
          } else {
            this.createItem({ data: this.form })
              .then(() => {
                this.$emit('update:visible', false);
              }).catch(() => {});
          }
        }
      });
    },
  },
};
</script>
